// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mbv3","question":"styles_question__3G_Zv","description":"styles_description__3kUkY"};